import { EBonusMaxBet, IUniversalPayout } from '@lbs/shared-rp-types'
import prp2boxHttp from '../../services/prp2boxHttp'

export interface IRpBonus {
  id: number
  name: string
  status: number
  min: number
  maxPayout: number | null
  payouts: IUniversalPayout[]
  max: EBonusMaxBet
  createdAt: string
  updatedAt: string
}

export interface CreateRpBonusPayload extends Pick<IRpBonus, 'name' | 'min' | 'maxPayout' | 'payouts'> {}

class Bonuses {
  prefix: string = '/bonuses'

  getAll = async (params: {
    limit?: number
    offset?: number
  }): Promise<{
    rows: IRpBonus[]
    totalRows: number
  }> => {
    const response = await prp2boxHttp.get(`${this.prefix}`, {
      params,
    })

    return response.data
  }

  getById = async (id: number): Promise<IRpBonus> => {
    const response = await prp2boxHttp.get(`${this.prefix}/${id}`)

    return response.data
  }

  create = async (payload: CreateRpBonusPayload): Promise<void> => {
    const response = await prp2boxHttp.post(`${this.prefix}`, payload)

    return response.data
  }

  update = async (id: number, payload: CreateRpBonusPayload): Promise<void> => {
    const response = await prp2boxHttp.put(`${this.prefix}/${id}`, payload)

    return response.data
  }
}

export default new Bonuses()
